import authService from '../auth/auth-service';
import config from '../../config';

const _configAPITecnico = config.configAPITecnico();

class ContraSenhaService {
  /**
   * codigoFacial: comprovante de uso único da validação facial (ação CONTRA_SENHA), quando a API exigir (428).
   * Com exigência e sem comprovante válido devolve { etapaFacial, atividadeId, na, mensagem }.
   */
  async contraSenha(opcao, ocorrencia, na, codigoFacial = null){
    try{
      const _headerToken = authService.headerAPITecnico();
      if (codigoFacial) _headerToken['X-Facial-Code'] = codigoFacial;

      let response = await fetch(`${_configAPITecnico.URI_API}/contrasenha/gerar/${opcao}/${ocorrencia}/${na}`,{
        method: 'GET',
        headers: _headerToken
      });

      if(response.status === 200)
        return await response.json();

      const data = await response.json().catch(() => null);

      // A API resolve a atividade pela NA e devolve o atividadeId para abrir a validação facial.
      if (response.status === 428 && data?.etapaFacial)
        return {
          etapaFacial: true,
          atividadeId: data.atividadeId,
          na: data.na,
          mensagem: data.mensagem,
        };

      return {
        error: true,
        message: data?.erro || null,
      };

    }catch (error) {
      // Falha de rede, CORS ou timeout. Sem isso a falha de comunicacao chegava
      // na tela como "ocorrencia nao encontrada", que manda o tecnico conferir
      // o numero errado.
      console.log(error);

      return {
        error: true,
        message: 'Falha de comunicação com o servidor. Verifique sua conexão e tente novamente.',
      };
    } 
  }

}
export default new ContraSenhaService();
